import reading from "../assets/reading.jpg";
import carrom from "../assets/carrom.jpg";
export const experienceItems = [
  {
    duration: "June 2020 - August 2020",
    title: "Front-end Developer - Arviti Infotech",
    subtitle:
      "Developed the company's tracker system using HTML, CSS and Bootstrap.",
  },
  {
    duration: "December 2021 - January 2022",
    title: "Intern - Verzeo",
    subtitle: "Made an application using MongoDB, Node.js and EJS.",
  },
  {
    duration: "July 2022 - October 2022",
    title: "MERN Stack Developer - Skillcoup",
    subtitle:
      "Made forms for the Skillcoup Website using MERN Stack and MDBootstrap. Scrum and Agile Methodology was used with Jira Software.",
  },
];

export const hobbiesItem = [
  {
    title: "Reading",
    image: reading,
  },
  {
    title: "Carrom",
    image: carrom,
  },
];

export const badges = [
  "HTML",
  "CSS",
  "Bootstrap",
  "Tailwind",
  "SASS",
  "LESS",
  "Javascript",
  "React",
  "Material UI",
  "Redux",
];

export const buttons = [
  { content: "CSS" },
  { content: "SASS" },
  { content: "LESS" },
  { content: "Bootstrap" },
  { content: "Tailwind" },
  { content: "React" },
];
